import { gql } from '@apollo/client';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
/**
 * @fragment SaleItemFileFragment
 * @since 1.0.0
 */
export const SaleItemFileFragment = gql `
  fragment SaleItemFileFragment on SaleItemFile {
    id
    createdAt
    updatedAt
    visibility

    file {
      ...MediaFragment
    }

    language {
      ...LanguageFragment
    }
  }

  ${MediaFragment}
  ${LanguageFragment}
`;
